import React, { Component } from 'react'
import './App.css'
import AppState from '../../State'
import Slide from '../Slide/Slide'
import NavigationArrow from '../../Components/NavigationArrow/NavigationArrow'
import Layout from '../Layout/Layout'
import LocationIndicator from '../../Components/LocationIndicator/LocationIndicator'
import LanguageSwitcher from '../../Components/LanguageSwitcher/LanguageSwitcher'
import BackToStartBtn from '../../Components/BackToStartBtn/BackToStartBtn'
import Swipeable from 'react-swipeable'
import Idle from '../../Components/Idle/Idle'
// import Logger from '../../Components/Logger/Logger'
const Rx = require('rx')

class App extends Component {
  constructor (props) {
    super(props)

    this.state = AppState
    this.slideRefs = []

    this.handleNavigationArrowClick = this.handleNavigationArrowClick.bind(this)
    this.handleLangSwitcherClick = this.handleLangSwitcherClick.bind(this)
    this.handleLocationIndicatorClick = this.handleLocationIndicatorClick.bind(this)
    this.onIdleStateChange = this.onIdleStateChange.bind(this)
  }

  componentDidMount () {
    this.attachAdminHelper()
  }

  attachAdminHelper () {
    // Listen for 6 consequent clicks in three seconds and ask to reload the app if observed.
    const source = Rx.Observable.fromEvent(window, 'click')
    source.windowWithTime(3000, 2000)   // create 3 second windows, two seconds apart
      .flatMap(window => window.count()) // take each window and get the count once it completes (after 3 seconds)
      .subscribe(count => {
        if (count >= 6) {
          if (window.confirm('Do you want to reload the application?')) {
            window.location.reload(true)
          }
        }
      })
  }

  setStateAsync (state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  getNextSlide () {
    let s = this.state
    let currentLanguage = s.currentLanguage
    let slides = s.slides[currentLanguage]

    if (s.currentSlide < slides.length - 1) {
      return slides[s.currentSlide + 1]
    }

    return s.slides[s.currentSlide]
  }

  getPreviousSlide () {
    let s = this.state
    let currentLanguage = s.currentLanguage
    let slides = s.slides[currentLanguage]

    if (s.currentSlide < 1) {
      return slides[0]
    }

    return slides[s.currentSlide - 1]
  }

  getSlide (index) {
    return this.state.slides[this.state.currentLanguage][index]
  }

  getDirection (index) {
    let currentIndex = this.state.currentSlide

    if (index < currentIndex) {
      return -1
    } else if (index > currentIndex) {
      return 1
    } else {
      return 0
    }
  }

  tween (scrollContainer, start, end, duration, easing) {
    return new Promise(resolve => {
      var delta = end - start
      var startTime

      if (window.performance && window.performance.now) {
        startTime = window.performance.now()
      } else if (Date.now) {
        startTime = Date.now()
      } else {
        startTime = new Date().getTime()
      }

      let tweenLoop = (time) => {
        let t = (!time ? 0 : time - startTime)
        let factor = easing(null, t, 0, 1, duration)
        scrollContainer.scrollTop = start + delta * factor
        if (t < duration && scrollContainer.scrollTop !== end) {
          window.requestAnimationFrame(tweenLoop)
        } else {
          resolve()
        }
      }

      tweenLoop()
    })
  }

  async transitionToSlide (index) {
    if (this.state.animating) {
      return
    }

    let toSlide = this.getSlide(index)
    let direction = this.getDirection(index)

    if (direction === 0) {
      return
    }

    const scrollContainer = this.scrollContainer
    let target = this.slideRefs[toSlide.index].domElement
    let fromPoint = scrollContainer.scrollTop
    let toPoint = target.offsetTop
    let inTime = this.state.scrollDuration
    let withEasing = this.state.easings.easeInOutExpo

    await this.setStateAsync({animating: true})

    if (direction === -1) {
      target.classList.add('fadeInDown')
      setTimeout(() => {
        target.classList.remove('fadeInDown')
      }, 1000)
    } else if (direction === 1) {
      target.classList.add('fadeInUp')
      setTimeout(() => {
        target.classList.remove('fadeInUp')
      }, 1000)
    }

    if (direction === -1) {
      await this.tween(scrollContainer, fromPoint, toPoint, inTime, withEasing)
    } else if (direction === 1) {
      await this.tween(scrollContainer, fromPoint, toPoint, inTime, withEasing)
    }
    await this.setStateAsync({animating: false, currentSlide: toSlide.index})
  }

  handleNavigationArrowClick (direction) {
    let toSlide = (direction === 'up') ? this.getPreviousSlide() : this.getNextSlide()
    this.transitionToSlide(toSlide.index)
  }

  handleBackToStartBtnClick () {
    this.transitionToSlide(0)
  }

  handleLangSwitcherClick (e, langCode) {
    e.stopPropagation()
    this.setState({currentLanguage: langCode})
  }

  handleLocationIndicatorClick (e, slideIndex) {
    e.stopPropagation()
    this.transitionToSlide(slideIndex)
  }

  onIdleStateChange (isIdle) {
    this.setState({isIdle: isIdle})
    if (isIdle) {
      this.setState({currentLanguage: this.state.defaultLang})
      this.transitionToSlide(0)
    }
  }

  render () {
    let { currentSlide, languages, currentLanguage, animating, idleTimeout } = this.state
    let slides = this.state.slides[currentLanguage]
    let topArrowVisible = currentSlide !== 0
    let bottomArrowVisible = currentSlide !== slides.length - 1
    let langSwitcherVisible = (currentSlide !== 0 && currentSlide !== slides.length - 1 && !animating)
    let backToStartBtnVisible = (currentSlide === slides.length - 1)
    let isFirstSlide = (currentSlide === 0)
    let isLastSlide = (currentSlide === slides.length - 1)

    return (
      <div className='App-WrapOuter'>
        <Idle timeout={idleTimeout} onIdleStateChange={this.onIdleStateChange} events={['click']} />
        <Swipeable
          trackMouse
          delta={100}
          onSwipingUp={e => {
            if (!isLastSlide) {
              this.handleNavigationArrowClick('down')
            }
          }}
          onSwipingDown={e => {
            if (!isFirstSlide) {
              this.handleNavigationArrowClick('up')
            }
          }}>
          <div className='App' ref={(scrollContainer) => { this.scrollContainer = scrollContainer }}>
            <div className='App-ContentWrap'>
              {slides.map((s) => {
                return (
                  <Slide key={s.index} ref={(slide) => { this.slideRefs[s.index] = slide }}>
                    <Layout type={s.mainLayoutType} content={s.content} currentSlide={currentSlide} slideIndex={s.index} />
                  </Slide>
                )
              })}
            </div>
          </div>
        </Swipeable>

        <NavigationArrow
          visible={topArrowVisible}
          direction='up'
          onClick={e => {
            e.stopPropagation()
            this.handleNavigationArrowClick('up')
          }} />

        <NavigationArrow
          visible={bottomArrowVisible}
          direction='down'
          onClick={e => {
            e.stopPropagation()
            this.handleNavigationArrowClick('down')
          }} />

        <BackToStartBtn
          visible={backToStartBtnVisible}
          onClick={e => {
            e.stopPropagation()
            this.handleBackToStartBtnClick()
          }} />

        <LocationIndicator
          slides={slides}
          currentSlide={currentSlide}
          handleLocationIndicatorClick={this.handleLocationIndicatorClick} />

        <LanguageSwitcher
          visible={langSwitcherVisible}
          languages={languages}
          currentLanguage={currentLanguage}
          handleLangSwitcherClick={this.handleLangSwitcherClick} />

        {/* <Logger state={this.state} messages='' /> */}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/Containers/App/App.js